window.CartonProduct = {
  // --- Configuration & State ---
  selectedVariantId: null,
  quantity: 1,
  elements: { // DOM element references
    section: null,
    productFormElement: null,
    form: null,
    quantityInput: null,
    quantityDecrease: null,
    quantityIncrease: null,
    skuDisplay: null,
    mainPriceDisplay: null,
    perPiecePriceDisplay: null,
    totalPriceDisplay: null,
    variantButtons: [],
    addToCartButton: null,
    nativeVariantInputs: [],
    variantIdInputs: [],
    bestValueBadge: null,
    savingsBadge: null,
  },

  // --- Initialization ---
  init: function(sectionElement) {
    this.elements.section = sectionElement;
    if (!this.elements.section) {
      console.error('CartonProduct: Section element not provided for init.');
      this.elements.section = document.querySelector('.carton-product[data-section-id]');
      if (!this.elements.section) {
        console.error('CartonProduct: Product section container (.carton-product) not found.');
        return;
      }
    }

    // Find DOM elements with new structure
    this.elements.productFormElement = this.elements.section.querySelector('product-form[data-js-product-form]');
    this.elements.form = this.elements.section.querySelector('form[data-type="add-to-cart-form"]');
    this.elements.quantityInput = this.elements.section.querySelector('.carton-product__quantity-input');
    this.elements.quantityDecrease = this.elements.section.querySelector('.carton-product__quantity-button:first-child');
    this.elements.quantityIncrease = this.elements.section.querySelector('.carton-product__quantity-button:last-child');
    this.elements.skuDisplay = this.elements.section.querySelector('.carton-product__sku');
    this.elements.mainPriceDisplay = this.elements.section.querySelector('.carton-product__main-price');
    this.elements.perPiecePriceDisplay = this.elements.section.querySelector('.carton-product__per-piece-price');
    this.elements.totalPriceDisplay = this.elements.section.querySelector('.carton-product__total-price');
    this.elements.variantButtons = Array.from(this.elements.section.querySelectorAll('.carton-product__variant-button'));
    this.elements.addToCartButton = this.elements.section.querySelector('.carton-product__add-to-cart');
    this.elements.bestValueBadge = this.elements.section.querySelector('.carton-product__best-value-badge');
    this.elements.savingsBadge = this.elements.section.querySelector('.carton-product__savings-badge');

    // Cache native variant controls and the actual id inputs Shopify submits
    this.elements.nativeVariantInputs = Array.from(
      this.elements.section.querySelectorAll('.native-variant-picker-wrapper [data-variant-id], product-variants [data-variant-id]')
    );
    if (this.elements.form) {
      this.elements.variantIdInputs = Array.from(this.elements.form.querySelectorAll('input[name="id"], select[name="id"]'));
    }

    if (this.elements.variantButtons.length === 0) {
      console.warn('CartonProduct: No custom variant buttons found.');
    }

    if (!this.elements.quantityInput) {
      console.warn('CartonProduct: Quantity input not found. Defaulting quantity to 1.');
      this.quantity = 1;
    } else {
      this.quantity = parseInt(this.elements.quantityInput.value) || 1;
    }

    this.addEventListeners();
    this.setupCartDrawerListener();
    this.setInitialVariant();
    this.setupAccessibility();
    this.hideNoReviewsText();
    console.log('CartonProduct initialized for section:', this.elements.section.dataset.sectionId);
  },

  setInitialVariant: function() {
    let initialVariantId = null;

    // Check for selected variant button
    const selectedButton = this.elements.variantButtons.find(button => 
      button.classList.contains('carton-product__variant-button--selected'));
    
    if (selectedButton) {
      initialVariantId = selectedButton.dataset.variantId;
    }

    // Fallback to first variant button
    if (!initialVariantId && this.elements.variantButtons.length > 0) {
      const firstButton = this.elements.variantButtons[0];
      initialVariantId = firstButton.dataset.variantId;
      firstButton.classList.add('carton-product__variant-button--selected');
    }

    if (initialVariantId) {
      this.selectedVariantId = initialVariantId;
      this.updateVariantSelection();
    }
  },

  addEventListeners: function() {
    // Variant button clicks
    this.elements.variantButtons.forEach(button => {
      button.addEventListener('click', this.handleVariantSelection.bind(this));
    });

    // Quantity input changes
    if (this.elements.quantityInput) {
      this.elements.quantityInput.addEventListener('change', this.handleQuantityChange.bind(this));
      this.elements.quantityInput.addEventListener('input', this.handleQuantityChange.bind(this));
    }

    // Quantity decrease button
    if (this.elements.quantityDecrease) {
      this.elements.quantityDecrease.addEventListener('click', (e) => {
        e.preventDefault();
        this.decreaseQuantity();
      });
    }

    // Quantity increase button
    if (this.elements.quantityIncrease) {
      this.elements.quantityIncrease.addEventListener('click', (e) => {
        e.preventDefault();
        this.increaseQuantity();
      });
    }

    // Add to cart button
    if (this.elements.addToCartButton) {
      this.elements.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    }
  },

  setupCartDrawerListener: function() {
    if (!this.elements.productFormElement || !window.KROWN) return;
    const cartAction = window.KROWN.settings?.cart_action;
    if (cartAction !== 'overlay' && cartAction !== 'popup') return;

    let addToCartEnter = false;
    if (this.elements.addToCartButton) {
      this.elements.addToCartButton.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') {
          addToCartEnter = true;
          window.lastFocusedElm = this.elements.addToCartButton;
        }
      });
    }

    this.elements.productFormElement.addEventListener('add-to-cart', () => {
      const sidebar = document.getElementById('site-cart-sidebar');
      if (sidebar && typeof sidebar.show === 'function') {
        sidebar.show();
        const cartRecommendations = document.getElementById('cart-recommendations');
        cartRecommendations?.generateRecommendations?.();

        if (addToCartEnter) {
          setTimeout(() => {
            sidebar.querySelector('[data-js-close]')?.focus();
            addToCartEnter = false;
          }, 200);
        }
      }
    });
  },

  handleVariantSelection: function(event) {
    const selectedButton = event.currentTarget;
    const newVariantId = selectedButton.dataset.variantId;

    if (this.selectedVariantId === newVariantId) return; // Already selected

    this.selectedVariantId = newVariantId;
    this.updateVariantSelection();
  },

  updateVariantSelection: function() {
    // Update button UI
    this.elements.variantButtons.forEach(button => {
      const isSelected = button.dataset.variantId === this.selectedVariantId;
      button.classList.toggle('carton-product__variant-button--selected', isSelected);
      button.setAttribute('aria-checked', isSelected.toString());
    });

    // Update Best Value badge and savings info box visibility
    this.updateBadgeAndInfoBox();

    // Update native form inputs if they exist
    const selectedButton = this.elements.variantButtons.find(button => 
      button.dataset.variantId === this.selectedVariantId);
    
    if (selectedButton) {
      const matchingNative = this.elements.nativeVariantInputs.find(input => 
        input.dataset.variantId === this.selectedVariantId
      );

      if (matchingNative) {
        if (matchingNative.tagName === 'INPUT') {
          if (!matchingNative.checked) {
            matchingNative.checked = true;
          }
          matchingNative.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        } else if (matchingNative.tagName === 'OPTION') {
          const selectEl = matchingNative.closest('select');
          if (selectEl) {
            selectEl.value = matchingNative.value;
            selectEl.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
          }
        }
      } else if (this.elements.variantIdInputs.length > 0) {
        const changeEvent = new Event('change', { bubbles: true, cancelable: true });
        this.elements.variantIdInputs.forEach(input => {
          input.value = this.selectedVariantId;
          input.dispatchEvent(changeEvent);
        });
      }
    }

    this.updateDisplays();
  },

  handleQuantityChange: function(event) {
    const newQuantity = parseInt(event.target.value);
    if (isNaN(newQuantity) || newQuantity < 1) {
      this.quantity = 1;
      if (this.elements.quantityInput) this.elements.quantityInput.value = 1;
    } else {
      this.quantity = newQuantity;
    }
    this.updateDisplays();
  },

  decreaseQuantity: function() {
    if (this.quantity > 1) {
      this.quantity--;
      if (this.elements.quantityInput) {
        this.elements.quantityInput.value = this.quantity;
      }
      this.updateDisplays();
    }
  },

  increaseQuantity: function() {
    this.quantity++;
    if (this.elements.quantityInput) {
      this.elements.quantityInput.value = this.quantity;
    }
    this.updateDisplays();
  },

  updateDisplays: function() {
    const selectedButton = this.elements.variantButtons.find(button => 
      button.dataset.variantId === this.selectedVariantId);
    
    if (!selectedButton) return;

    const variantData = selectedButton.dataset;
    
    // Update SKU
    if (this.elements.skuDisplay && variantData.variantSku) {
      this.elements.skuDisplay.textContent = `SKU: ${variantData.variantSku}`;
    }

    const isAvailable = variantData.variantAvailable === 'true';

    // Update prices
    const priceInCents = parseFloat(variantData.variantPrice) || 0;
    const priceFormatted = this.formatMoney(priceInCents);

    if (this.elements.mainPriceDisplay) {
      this.elements.mainPriceDisplay.textContent = priceFormatted;
    }

    // Update per-piece price calculation
    if (this.elements.perPiecePriceDisplay) {
      // Get variant data for calculations
      if (this.elements.variantButtons.length > 0) {
        const firstVariant = this.elements.variantButtons[0];
        const packQuantity = parseInt(firstVariant.dataset.packQuantity) || 0;
        const cartonQuantity = parseInt(firstVariant.dataset.cartonQuantity) || 0;
        const firstVariantName = firstVariant.textContent.toLowerCase().trim();
        
        // Hide per-piece display if no valid metafield data
        if (!packQuantity || !cartonQuantity || packQuantity <= 0 || cartonQuantity <= 0) {
          this.elements.perPiecePriceDisplay.style.display = 'none';
          return;
        }
        
        // Show per-piece display for multi-piece products
        this.elements.perPiecePriceDisplay.style.display = 'block';
        
        // Calculate per-piece price based on selected variant
        const selectedVariantPieces = this.getPiecesForVariant(selectedButton);
        if (selectedVariantPieces > 0) {
          const unitPrice = priceInCents / selectedVariantPieces;
          const unitPriceFormatted = this.formatMoney(unitPrice);
          
          // Simple logic for both variants - just show pieces for current variant
          const currentVariantPieces = this.getPiecesForVariant(selectedButton);
          const display = `${unitPriceFormatted} pc · ${currentVariantPieces} pieces`;
          
          this.elements.perPiecePriceDisplay.textContent = display;
        }
      }
    }

    // Update total price with piece count
    if (this.elements.totalPriceDisplay) {
      const totalPrice = priceInCents * this.quantity;
      const totalPriceFormatted = this.formatMoney(totalPrice);
      
      // Calculate total pieces
      const selectedVariantPieces = this.getPiecesForVariant(selectedButton);
      const totalPieces = selectedVariantPieces * this.quantity;
      
      // Update with enhanced display
      this.elements.totalPriceDisplay.innerHTML = 
        `${totalPriceFormatted} <span class="carton-product__total-pieces">(${totalPieces} Pieces)</span>`;
    }

    // Update add to cart button
    if (this.elements.addToCartButton) {
      this.elements.addToCartButton.disabled = !isAvailable;
      this.elements.addToCartButton.textContent = isAvailable ? 'Add to cart' : 'Sold Out';
    }
  },

  updateBadgeAndInfoBox: function() {
    const selectedButton = this.elements.variantButtons.find(button => 
      button.dataset.variantId === this.selectedVariantId);
    
    if (!selectedButton) return;

    // Determine if carton is selected (assuming carton is the second variant)
    const variantIndex = this.elements.variantButtons.findIndex(b => 
      b.dataset.variantId === this.selectedVariantId);
    const isCartonSelected = variantIndex === 1;

    // Update Best Value badge visibility
    if (this.elements.bestValueBadge) {
      this.elements.bestValueBadge.classList.toggle('carton-product__best-value-badge--visible', isCartonSelected);
    }

    // Update savings badge visibility
    if (this.elements.savingsBadge) {
      this.elements.savingsBadge.classList.toggle('carton-product__savings-badge--visible', isCartonSelected);
    }
  },

  getPiecesForVariant: function(button) {
    // Get variant position to determine which metafield to use
    const variantIndex = this.elements.variantButtons.findIndex(b => 
      b.dataset.variantId === button.dataset.variantId);
    
    // First variant (index 0) = packet, uses pack_quantity
    // Second variant (index 1) = carton, uses carton_quantity
    if (variantIndex === 0) {
      return parseInt(button.dataset.packQuantity) || 1;
    } else {
      return parseInt(button.dataset.cartonQuantity) || 1;
    }
  },

  formatMoney: function(cents) {
    // Basic money formatting - in a real implementation, use Shopify.formatMoney
    const dollars = cents / 100;
    return `$${dollars.toFixed(2)}`;
  },

  handleAddToCart: function(event) {
    event.preventDefault();
    
    const selectedButton = this.elements.variantButtons.find(button => 
      button.dataset.variantId === this.selectedVariantId);
    
    if (!selectedButton) return;
    
    const isAvailable = selectedButton.dataset.variantAvailable === 'true';
    if (!isAvailable) return;

    // Submit the form if it exists
    if (this.elements.form) {
      // Update quantity in form
      const formQuantityInput = this.elements.form.querySelector('input[name="quantity"]');
      if (formQuantityInput) {
        formQuantityInput.value = this.quantity;
      }

      if (typeof this.elements.form.requestSubmit === 'function') {
        this.elements.form.requestSubmit();
      } else {
        const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
        this.elements.form.dispatchEvent(submitEvent);
      }
    }
  },

  setupAccessibility: function() {
    // Set up variant buttons as radio group
    const variantSection = this.elements.section.querySelector('.carton-product__variant-section');
    if (variantSection && this.elements.variantButtons.length > 0) {
      variantSection.setAttribute('role', 'radiogroup');
      variantSection.setAttribute('aria-label', 'Buy As');

      this.elements.variantButtons.forEach((button, index) => {
        button.setAttribute('role', 'radio');
        button.setAttribute('tabindex', index === 0 ? '0' : '-1');
        
        button.addEventListener('keydown', (event) => {
          this.handleKeyboardNavigation(event, index);
        });
      });
    }

    // Set up quantity input accessibility
    if (this.elements.quantityInput) {
      this.elements.quantityInput.setAttribute('aria-label', 'Quantity');
      this.elements.quantityInput.setAttribute('min', '1');
    }

    if (this.elements.quantityDecrease) {
      this.elements.quantityDecrease.setAttribute('aria-label', 'Decrease quantity');
    }

    if (this.elements.quantityIncrease) {
      this.elements.quantityIncrease.setAttribute('aria-label', 'Increase quantity');
    }
  },

  handleKeyboardNavigation: function(event, currentIndex) {
    let newIndex = currentIndex;
    const totalButtons = this.elements.variantButtons.length;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      newIndex = (currentIndex + 1) % totalButtons;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      newIndex = (currentIndex - 1 + totalButtons) % totalButtons;
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.elements.variantButtons[currentIndex].click();
      return;
    } else {
      return;
    }

    // Update tabindex and focus
    this.elements.variantButtons.forEach((button, index) => {
      button.setAttribute('tabindex', index === newIndex ? '0' : '-1');
    });
    this.elements.variantButtons[newIndex].focus();
  },

  // --- Hide "No reviews" Text ---
  hideNoReviewsText: function() {
    const ratingCaption = this.elements.section.querySelector('.star-rating__caption');
    if (ratingCaption && ratingCaption.textContent.trim() === 'No reviews') {
      ratingCaption.style.display = 'none';
      console.log('CartonProduct: "No reviews" text hidden');
    }
  },

};

// --- Initialization Trigger ---
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.carton-product[data-section-id]').forEach(sectionElement => {
      const cartonProductInstance = Object.create(window.CartonProduct);
      cartonProductInstance.init(sectionElement);
    });
  });
} else {
  document.querySelectorAll('.carton-product[data-section-id]').forEach(sectionElement => {
    const cartonProductInstance = Object.create(window.CartonProduct);
    cartonProductInstance.init(sectionElement);
  });
}

// Shopify Theme Editor Support
document.addEventListener('shopify:section:load', function(event) {
  const sectionElement = event.target.querySelector('.carton-product[data-section-id]');
  if (sectionElement && event.detail.sectionId === sectionElement.dataset.sectionId) {
    const cartonProductInstance = Object.create(window.CartonProduct);
    cartonProductInstance.init(sectionElement);
  }
});
